import { defineMessages } from 'react-intl';

export const allowListMessages = defineMessages({
    purposes: {
        id: 'purposes',
        defaultMessage: 'Purposes',
    },
    type: {
        id: 'type',
        defaultMessage: 'Type',
    },
    whitelist: {
        id: 'whitelist',
        defaultMessage: 'Whitelist',
    },
    blacklist: {
        id: 'blacklist',
        defaultMessage: 'Blacklist',
    },
    reservation: {
        id: 'reservation',
        defaultMessage: 'Reservation',
    },
    subscription: {
        id: 'subscription',
        defaultMessage: 'Subscription',
    },
    ev: {
        id: 'ev',
        defaultMessage: 'EV',
    },
    entrance: {
        id: 'entrance',
        defaultMessage: 'Entrance',
    },
    allowLists: {
        id: 'allow-lists',
        defaultMessage: 'Allow lists',
    },
    allowList: {
        id: 'allow-list',
        defaultMessage: 'Allow list',
    },
    createAllowListModalSubtitle: {
        id: 'create-allow-list-modal-subtitle',
        defaultMessage: 'Add a new allow list',
    },
    deleteAllowListSubtitle: {
        id: 'delete-allow-list-subtitle',
        defaultMessage: 'Permanently delete allow list {entry}',
    },
    editAllowListSubtitle: {
        id: 'edit-allow-list-subtitle',
        defaultMessage: 'Edit allow list {entry}',
    },
    confirmDeleteAllowList: {
        id: 'confirm-delete-allow-list',
        defaultMessage: 'Are you sure you want to delete allow list {entry}? This action cannot be undone.',
    },
    createAllowListSuccess: {
        id: 'create-allow-list-success',
        defaultMessage: 'Allow list created',
    },
    updateAllowListSuccess: {
        id: 'update-allow-list-success',
        defaultMessage: 'Allow list updated',
    },
    deleteAllowListSuccess: {
        id: 'delete-allow-list-success',
        defaultMessage: 'Allow list deleted',
    },
    createAllowListSuccessDescription: {
        id: 'create-allow-list-success-description',
        defaultMessage: 'Allow list {entry} has been successfully created.',
    },
    updateAllowListSuccessDescription: {
        id: 'update-allow-list-success-description',
        defaultMessage: 'Allow list {entry} has been successfully updated.',
    },
    deleteAllowListSuccessDescription: {
        id: 'delete-allow-list-success-description',
        defaultMessage: 'Allow list {entry} has been successfully deleted.',
    },
    identifier: {
        id: 'identifier',
        defaultMessage: 'Identifier',
    },
    email: {
        id: 'email',
        defaultMessage: 'Email',
    },
    member: {
        id: 'member',
        defaultMessage: 'Member',
    },
    members: {
        id: 'members',
        defaultMessage: 'Members',
    },
    groupName: {
        id: 'group',
        defaultMessage: 'Group',
    },
    backToAllLists: {
        id: 'back-to-all-lists',
        defaultMessage: 'Back to all lists',
    },

    createMemberModalSubtitle: {
        id: 'create-member-modal-subtitle',
        defaultMessage: 'Add a new member',
    },
    deleteMemberSubtitle: {
        id: 'delete-member-subtitle',
        defaultMessage: 'Permanently delete member {entry}',
    },
    editMemberSubtitle: {
        id: 'edit-member-subtitle',
        defaultMessage: 'Edit member {entry}',
    },
    confirmDeleteMember: {
        id: 'confirm-delete-member',
        defaultMessage: 'Are you sure you want to delete member {entry}? This action cannot be undone.',
    },
    createMemberSuccess: {
        id: 'create-member-success',
        defaultMessage: 'Member created',
    },
    updateMemberSuccess: {
        id: 'update-member-success',
        defaultMessage: 'Member updated',
    },
    deleteMemberSuccess: {
        id: 'delete-member-success',
        defaultMessage: 'Member deleted',
    },
    createMemberSuccessDescription: {
        id: 'create-member-success-description',
        defaultMessage: 'Member {entry} has been successfully created.',
    },
    updateMemberSuccessDescription: {
        id: 'update-member-success-description',
        defaultMessage: 'Member {entry} has been successfully updated.',
    },
    deleteMemberSuccessDescription: {
        id: 'delete-member-success-description',
        defaultMessage: 'Member {entry} has been successfully deleted.',
    },
});
